import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ChallengeService, TeamMembershipStatus } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';
/**
 * Component to display user list item in next challenge tab
 */
var NextChallengeUserComponent = (function () {
    function NextChallengeUserComponent(challengeService, translate, snackBar) {
        this.challengeService = challengeService;
        this.translate = translate;
        this.snackBar = snackBar;
        this.confirmMode = false;
        this.ngUnsubscribe = new Subject();
        // Reference to TeamMembershipStatus to be able to use it in template
        this.TeamMembershipStatus = TeamMembershipStatus;
    }
    NextChallengeUserComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.challengeService.teamUser.takeUntil(this.ngUnsubscribe).subscribe(function (teamUser) {
            _this.loggedInUser = teamUser;
        });
    };
    /**
     * Switch to confirmation mode
     */
    NextChallengeUserComponent.prototype.displayConfirmMode = function () {
        this.confirmMode = true;
    };
    /**
     * Cancel confirmation mode
     */
    NextChallengeUserComponent.prototype.cancelConfirmMode = function () {
        this.confirmMode = false;
    };
    /**
     * Removes the given user from the team
     */
    NextChallengeUserComponent.prototype.removeUser = function () {
        var _this = this;
        this.challengeService.removeUserFromTeam(this.challenge._id, this.team._id, this.user._id).catch(function () {
            _this.challengeService.reloadTeams();
        });
    };
    /**
     * Accept application of a user to the team
     */
    NextChallengeUserComponent.prototype.acceptApplication = function () {
        var _this = this;
        this.challengeService.acceptApplication(this.challenge._id, this.team._id, this.user._id).catch(function (error) {
            var errorObject = error.body.error.error;
            if (errorObject.startsWith('maximum_challenge_members')) {
                _this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            }
            _this.challengeService.reloadTeams();
        });
    };
    /**
     * Cancels application of a user to the team
     */
    NextChallengeUserComponent.prototype.declineApplication = function () {
        var _this = this;
        this.challengeService.cancelApplication(this.challenge._id, this.team._id, this.user._id).catch(function () {
            _this.challengeService.reloadTeams();
        });
    };
    /**
     * Cancels an invitation of the user to the team
     */
    NextChallengeUserComponent.prototype.cancelInvitation = function () {
        var _this = this;
        this.challengeService.declineInvitation(this.challenge._id, this.team._id, this.user.email).catch(function () {
            _this.challengeService.reloadTeams();
        });
    };
    /**
     * On destroy cancel active subscriptions
     */
    NextChallengeUserComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return NextChallengeUserComponent;
}());
export { NextChallengeUserComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/challenge-statistics/components/next-challenge-user/next-challenge-user.component.ts.pre-build-optimizer.js